

function getPhotoData(url) {
    return $.ajax({
        url: url,
        method: "GET",
        contentType: "json"
    });
} 

function addSlides(data) {
    for (let i = 0; i < data.length; i++) {

        let d = new Date(data[i].datetaken);
        let taken = new Intl.DateTimeFormat('en-US').format(d);

        let p2 = "<p class=\"sp-layer sp-black sp-padding\" data-position=\"bottomLeft\" data-vertical=\"0\" data-width=\"100%\" data-show-transition=\"up\"><i class=\"fas fa-camera\" aria-hidden=\"true\" ></i>" +
            "<span style=\"margin-left:4px;\">" + taken + "</span><span style=\"margin-left:8px;\">Building: " + data[i].card + "</span><span style=\"margin-left:8px;\">Category: " + data[i].category + "</span></p>";

        let fname = data[i].filename;
        let thumb = "<img class=\"sp-thumbnail\" src=\"/wp-content/themes/frontier-child/images/mcpao-ph-thumb.gif\" data-src=\"" + "/photo.server/" + fname + "\"/>";
        $("#buildingPhotoViewer .sp-thumbnails").append($(thumb));

        let slide = "<div class=\"sp-slide\"><img class=\"sp-image\" src=\"/wp-content/themes/frontier-child/images/mcpao-ph-slide.jpg\" data-src=\"" + "/photo.server/" + fname + "\" />" + p2 + "</div>";
        $("#buildingPhotoViewer .sp-slides").append($(slide))
    }
} 

function loadPhotos(url, tabClicked) {
    return new Promise((resolve) => {
        getPhotoData(url)
            .then(function (result) {
                let photo_count = 0;
                let ph = document.getElementById('buildingPhoto');
                if (ph) {
                    let obj = JSON.parse(result);
                    if (obj.rows.length > 0) {
                        photo_count = obj.rows.length;
                        let parent = document.createElement('div');
                        parent.setAttribute("id", "buildingPhotoViewer");
                        parent.setAttribute("class", "pao-photos slider-pro d-none");

                        let slides = document.createElement('div');
                        slides.setAttribute("class", "sp-slides");
                        parent.appendChild(slides);

                        let thumbs = document.createElement('div');
                        thumbs.setAttribute("class", "sp-thumbnails");
                        parent.appendChild(thumbs);

                        ph.appendChild(parent);

                        let use_slider = true;

                        $.each(obj, function (idx, data) {
                            if (idx === 'rows') {
                                if (data.length > 0) {
                                    addSlides(data);
                                } else {
                                    (function () {
                                        let slide = "<div class=\"sp-no-photo\"><img class=\"no-photo\" src=\"" + paoDetails.images.nophoto + "\" /></div>";
                                        $("#buildingPhotoViewer").append($(slide));
                                        use_slider = false;
                                        return false;
                                    }());
                                }
                            }
                        });
                        if (use_slider) {
                            doSlider();
                        }
                        paoDetails.modules.photos.loaded = true;

                    } else {
                        paoDetails.modules.photos.loaded = tabClicked;
                    }
                    return photo_count;
                }
            })
            .then((result) => {
                resolve(result);
            });
    }).catch((err) => console.error(err));
}

function doSlider() {
    $('#buildingPhotoViewer').sliderPro({
        width: 551,
        height: 416,
        responsive: true,			
        imageScaleMode: 'contain', 	
        autoScaleLayers: true, 		
        autoplay: false,			
        arrows: true,				
        fadeArrows: true,			
        buttons: false,				
        fullScreen: true,			
        shuffle: false, 			
        waitForLayers: false,
        centerImage: true,
        thumbnailArrows: true,		
        thumbnailHeight: 85,
        thumbnailsPosition: 'bottom',
        fade: true,
        breakpoints: {
            1200: {
                width: 460,
                height: 370
            },
            992: {
                width: 370,
                height: 350
            },
            768: {
                width: 280,
                height: 310,
                thumbnailWidth: 100,
                thumbnailHeight: 70
            },
            576: {
                width: 200,
                height: 270,
                thumbnailWidth: 90,
                thumbnailHeight: 75
            },
            570: {
                width: 500,
                height: 400
            }
        }
    });
    $('#buildingPhotoViewer').sliderPro('resize');
}